// Generated by psc version 0.10.2
"use strict";
var Control_Alt = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-control/src/Control/Alt.purs");
var Data_Functor = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Functor.purs");
var Plus = function (__superclass_Control$dotAlt$dotAlt_0, empty) {
    this["__superclass_Control.Alt.Alt_0"] = __superclass_Control$dotAlt$dotAlt_0;
    this.empty = empty;
};
var plusArray = new Plus(function () {
    return Control_Alt.altArray;
}, [  ]);
var empty = function (dict) {
    return dict.empty;
};
module.exports = {
    Plus: Plus, 
    empty: empty, 
    plusArray: plusArray
};



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-control/src/Control/Plus.purs
// module id = 30
// module chunks = 0